module.exports = __webpack_public_path__ + "static/img/14050B_1_R_20221017_LC.a297c58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14050B_1_R_20221017_LC.png
// module id = dP9N
// module chunks = 0